// extracted by mini-css-extract-plugin
export var animationContainer = "_go-0";
export var asteriskIcon = "_go-8";
export var conversationLeftSection = "_go-4";
export var conversationListItem = "_go-3";
export var conversationMiddleSection = "_go-5";
export var conversationRightSection = "_go-6";
export var detailsContent = "_go-1";
export var listContainer = "_go-7";
export var modalContent = "_go-2";